import React from "react";
import { useSelector } from "react-redux";
import { IonLabel, IonItem, IonList, IonText } from "@ionic/react";
import currencyFormat from "../../../utils/currencyFormat";
import { InvoiceSummary } from "./InvoiceSummary";
import { selectPaymentNotice } from "../../../store/paymentNoticeDetail/selectors/selectPaymentNotice";
import { ClientSelector } from "./ClientSelector";

export const SegmentInfo: React.FC = () => {
  const paymentNotice = useSelector(selectPaymentNotice);

  return (
    <IonList>
      <ClientSelector />
      <IonItem lines="none">
        <IonLabel class="ion-text-wrap">
          <p>Empresa</p>
          <IonText color="primary">
            <strong>{paymentNotice.company?.name}</strong>
          </IonText>
        </IonLabel>
      </IonItem>
      <IonItem lines="none">
        <IonLabel>
          <p>Fecha</p>
          <IonText color="primary">
            <strong>{paymentNotice.payedAtLegible}</strong>
          </IonText>
        </IonLabel>
      </IonItem>
      <IonItem lines="none">
        <IonLabel>
          <p>Monto</p>
          <IonText color="primary">
            <strong>{currencyFormat(paymentNotice.amount || 0)}</strong>
          </IonText>
        </IonLabel>
      </IonItem>
      <InvoiceSummary />
    </IonList>
  );
};
